import React from 'react';

interface HeroMetricsProps {
  rentValue: number;
  sellValue: number;
  advantage: number;
  formatCurrency: (value: number, compact?: boolean) => string;
}

export const HeroMetrics: React.FC<HeroMetricsProps> = ({
  rentValue,
  sellValue,
  advantage,
  formatCurrency
}) => {
  return (
    <div className="grid grid-cols-3 gap-8 mb-8 py-6 border-b border-gray-200">
      <div>
        <p className="text-sm text-gray-500 mb-1">Keep & Rent</p>
        <p className="text-2xl font-medium text-gray-900 tabular-nums">
          {formatCurrency(rentValue, true)}
        </p>
        <p className="text-xs text-gray-400">10-year value</p>
      </div>

      <div>
        <p className="text-sm text-gray-500 mb-1">Sell & Invest</p>
        <p className="text-2xl font-medium text-gray-900 tabular-nums">
          {formatCurrency(sellValue, true)}
        </p>
        <p className="text-xs text-gray-400">80/20 portfolio</p>
      </div>

      <div>
        <p className="text-sm text-gray-500 mb-1">Difference</p>
        <p className="text-2xl font-medium text-gray-900 tabular-nums">
          {advantage >= 0 ? '+' : ''}{formatCurrency(advantage, true)}
        </p>
        <p className="text-xs text-gray-400">
          {advantage >= 0 ? 'Rent ahead' : 'Sell ahead'}
        </p>
      </div>
    </div>
  );
};
